(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ext/dhtmlxgantt_drag_timeline", [], factory);
	else if(typeof exports === 'object')
		exports["ext/dhtmlxgantt_drag_timeline"] = factory();
	else
		root["ext/dhtmlxgantt_drag_timeline"] = factory();
})(window, function() {
return 